import { render, staticRenderFns } from "./withdrawReview.vue?vue&type=template&id=8cbba684&scoped=true"
import script from "./withdrawReview.vue?vue&type=script&lang=js"
export * from "./withdrawReview.vue?vue&type=script&lang=js"
import style0 from "./withdrawReview.vue?vue&type=style&index=0&id=8cbba684&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cbba684",
  null
  
)

export default component.exports